/**
 * Done. / ChiroCPD — Onboarding Page (/onboarding)
 *
 * Wrapped in OnboardingLayout. Renders OnboardingSurvey.
 * No TopNav — linear flow before main app.
 */

import { OnboardingLayout } from '@/layouts/OnboardingLayout';
import { OnboardingSurvey } from '@/components/features/OnboardingSurvey';
import { AuthProvider } from '@/contexts/AuthContext';

// OnboardingPage manages its own step state via the survey component
export function OnboardingPage(): React.ReactElement {
  return (
    <AuthProvider>
      <OnboardingLayout step={1} totalSteps={5}>
        <OnboardingSurvey />
      </OnboardingLayout>
    </AuthProvider>
  );
}
